import React from 'react';
import Spinner from "react-bootstrap/Spinner";


export default function Loading({ size }: { size?: 'sm' }) {
    return (
        <Spinner animation="border" size={size} />
    );
}

